(function () {
  const defaultInfo = {
    enabled: false,
    collectable: false,
    missions: {
      checkin: {
        completed: false,
        times: 0,
      },
      comment: {
        completed: false,
        times: 0,
      },
      read_free: {
        completed: false,
        times: 0,
      },
      day_consume_4: {
        completed: false,
        times: 0,
      },
      day_consume_15: {
        completed: false,
        times: 0,
      },
      day_consume_50: {
        completed: false,
        times: 0,
      },
      day_consume_100: {
        completed: false,
        times: 0,
      },
      day_consume_12: {
        completed: false,
        times: 0,
      },
      day_consume_9: {
        completed: false,
        times: 0,
      },
      buy_1: {
        completed: false,
        times: 0,
      },
      buy_3: {
        completed: false,
        times: 0,
      },
    },
  };
  let USC1 = Cookies.get('USC1');
  const api = axios.create({
    baseURL: ApiBaseUrl,
    withCredentials: isProd,
    params: isProd
      ? null
      : {
          USC1: USC1,
        },
  });

  let info = defaultInfo;

  checkLogin();
  getInfo();
  bindEvent();

  function checkLogin() {
    if (USC1) {
      document.querySelector('#missions_login').classList.add('hide');
    } else {
      document.querySelector('#missions_progress').classList.add('hide');
      document.querySelector('#missions_login').classList.remove('hide');
      info = defaultInfo;
      setInfo();
    }
  }

  function getInfo() {
    if (!USC1) {
      return;
    }

    api
      .get('/events/RentaTW-7anniversary/info')
      .then((resp) => {
        info = resp.data.data;
        document.querySelector('#missions_progress').classList.remove('hide');
        setInfo();
        if (!info.enabled) {
          alert('活動已結束');
        }
      })
      .catch((error) => {
        // 身分驗證有問題
        USC1 = '';
        checkLogin();
      });
  }

  function setInfo() {
    if (info.enabled) {
      document.querySelector('#game').classList.add('enabled');
    } else {
      document.querySelector('#game').classList.remove('enabled');
    }

    let completedCount = 0;
    for (const key in info.missions) {
      const item = document.querySelector(`#mission_${key}`);
      const max = parseInt(item.querySelector('.max').innerHTML);
      const existence = Math.min(max, info.missions[key].times);
      item.querySelector('.existence').innerHTML = existence;

      // 已完成
      if (info.missions[key].completed) {
        item.classList.add('completed');
        completedCount++;
      } else {
        item.classList.remove('completed');
      }

      // 已達標
      if (
        !info.missions[key].completed &&
        max === existence &&
        info.collectable
      ) {
        item.classList.add('ready');
      } else {
        item.classList.remove('ready');
      }
    }

    const status1 = document.querySelector('#missions_progress .item1');
    status1.querySelector('.existence').innerHTML = Math.min(5, completedCount);
    if (completedCount >= 5) {
      status1.classList.add('completed');
    } else {
      status1.classList.remove('completed');
    }

    const status2 = document.querySelector('#missions_progress .item2');
    status2.querySelector('.existence').innerHTML = Math.min(8, completedCount);
    if (completedCount >= 8) {
      status2.classList.add('completed');
    } else {
      status2.classList.remove('completed');
    }

    const bar = document.querySelector('#missions_progress_bar');
    bar.classList.remove(...bar.classList);
    bar.classList.add('fill', `fill_${Math.min(8, completedCount)}`);
  }

  function bindEvent() {
    [].forEach.call(
      document.querySelectorAll('#missions_items .item'),
      (item) => {
        item.addEventListener(
          'click',
          (e) => {
            const element = e.currentTarget;
            missionCompleted(element);
          },
          true
        );
      }
    );
  }

  function missionCompleted(element) {
    if (
      !element.classList.contains('ready') ||
      element.classList.contains('completing')
    ) {
      return;
    }
    if (!info.enabled) {
      alert('活動已結束');
      return;
    }
    const missionName = element.getAttribute('data-mission');

    element.classList.add('completing');

    api
      .put(`/events/RentaTW-7anniversary/${missionName}/completed`)
      .then((resp) => {
        info.missions[missionName].completed = true;
        setInfo();
        // getInfo();
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          // 身分驗證有問題
          alert('請重新登入');
          USC1 = '';
          checkLogin();
        } else if (error.response?.status === 403) {
          alert(error.response.data.message);
          getInfo();
        }
        element.classList.remove('completing');
      });
  }
})();
